import { render } from "./Winspection.vue?vue&type=template&id=f60380e0&scoped=true"
const script = {}

import "./Winspection.vue?vue&type=style&index=0&id=f60380e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f60380e0"

export default script